// Head tags for the private Plunkets Admin installable app.
// Used only by /admin and /auth — never by public routes.
export const ADMIN_APP_META = [
  { name: "viewport", content: "width=device-width, initial-scale=1, viewport-fit=cover" },
  { name: "theme-color", content: "#0F1E22" },
  { name: "application-name", content: "Plunkets Admin" },
  { name: "apple-mobile-web-app-capable", content: "yes" },
  { name: "mobile-web-app-capable", content: "yes" },
  { name: "apple-mobile-web-app-title", content: "Plunkets Admin" },
  { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" },
];

export const ADMIN_APP_LINKS = [
  { rel: "manifest", href: "/admin.webmanifest" },
  { rel: "apple-touch-icon", href: "/admin-icons/apple-touch-icon.png" },
];
